export enum ExchangesEnum {
  Binance = 'binance',
}
